import api from "./api";
import endpoints from "./endpoints";

export default {
  getArticles: async function (args) {
    const { signal, ...params } = args;
    const response = await api.get(endpoints.variationGroups.articles.get, {
      params: params,
      signal: signal
    });
    return response.data;
  },
  moveArticleToPosition: async function (articleId, parentId, targetNodeId, targetPosition, catalogId) {
    const response = await api.post(
      endpoints.variationGroups.articles.moveTo,
      {},
      {
        params: {
          articleId,
          sourceParentId: parentId,
          targetNodeId,
          targetPosition,
          catalogId
        }
      }
    );
    return response.data;
  },
  deleteEmptyVariationGroups: async function (catalogId) {
    const response = await api.post(endpoints.variationGroups.deleteEmpty, {}, { params: { catalogId } });
    return response.data;
  },
  getMediaAssets: async function (variationGroupId, catalogId, languageCode) {
    const response = await api.get(endpoints.variationGroups.mediaAssets.get, {
      params: { variationGroupId, catalogId, languageCode: languageCode }
    });
    return response.data;
  },
  getInvariantAttributes(variationGroupId, language) {
    return api
      .get(endpoints.article.invariantAttributes.get, {
        params: { variationGroupId, language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getMultiArticleVariantAttributes(variationGroupId, language, articlePagesize, articlePageOffset) {
    return api
      .get(endpoints.variationGroups.attributes.get, {
        params: {
          variationGroupId,
          language,
          articlePagesize,
          articlePageOffset
        }
      })
      .then((x) => Promise.resolve(x.data));
  },
  getPricesForArticlesUnderVariationGroup(variationGroupId, catalogId) {
    return api
      .get(endpoints.variationGroups.prices.get, {
        params: { variationGroupId, catalogId }
      })
      .then((x) => Promise.resolve(x.data));
  },
  GetPriceAttributesFromArticleUnderVariationGroup(variationGroupId, catalogId, language) {
    return api
      .get(endpoints.variationGroups.priceAttributes.get, {
        params: { variationGroupId, catalogId, language }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updatePricesForArticlesUnderVariatonGroup(variationGroupId, prices) {
    return api
      .post(endpoints.variationGroups.prices.update, prices, {
        params: { variationGroupId }
      })
      .then((x) => Promise.resolve(x.data));
  },
  updateMediaAssetsUnderVariatonGroup(languageCode, articleMediaAssets) {
    return api
      .post(endpoints.variationGroups.mediaAssets.update, articleMediaAssets, {
        params: { languageCode }
      })
      .then((x) => Promise.resolve(x.data));
  }
};
